import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { HandHeart } from "lucide-react";

export default function Donate() {
  const [packages, setPackages] = useState([]);
  const [picked, setPicked] = useState(null);
  const [custom, setCustom] = useState("");
  const [donor, setDonor] = useState({ donor_name: "", donor_email: "", message: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/donation-packages").then(({ data }) => { setPackages(data); setPicked(data[1]?.package_id); });
  }, []);

  const donate = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/checkout/donation", {
        package_id: picked,
        custom_amount: picked === "custom" ? parseFloat(custom) : undefined,
        ...donor,
        origin_url: window.location.origin,
      });
      if (data?.url) window.location.href = data.url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not start donation");
      setBusy(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto px-6 py-10" data-testid="donate-page">
      <div className="text-center mb-8">
        <HandHeart className="h-10 w-10 text-pink-500 mx-auto" />
        <h1 className="font-display text-3xl md:text-4xl font-bold text-slate-900 mt-3">Donate to Autism Families</h1>
        <p className="text-slate-600 mt-2 max-w-xl mx-auto">Your gift funds AAC tablets, sensory kits, safety equipment, and direct family support.</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {packages.map((p) => (
          <button key={p.package_id} data-testid={`pkg-${p.package_id}`} onClick={() => setPicked(p.package_id)}
            className={`card-soft p-5 text-left ${picked === p.package_id ? "ring-2 ring-pink-400" : ""}`}>
            <div className="text-2xl font-display font-bold text-pink-600">${p.amount.toFixed(0)}</div>
            <div className="font-semibold text-slate-900 mt-1">{p.label}</div>
          </button>
        ))}
        <button data-testid="pkg-custom" onClick={() => setPicked("custom")} className={`card-soft p-5 text-left ${picked === "custom" ? "ring-2 ring-pink-400" : ""}`}>
          <div className="font-display font-bold text-pink-600">Custom</div>
          <Input data-testid="pkg-custom-amount" type="number" min="5" max="5000" value={custom} onChange={(e) => setCustom(e.target.value)} placeholder="$ Amount" className="mt-2" />
        </button>
      </div>

      <div className="card-soft p-6 mt-6 space-y-3">
        <Input data-testid="donor-name" placeholder="Your Name (optional)" value={donor.donor_name} onChange={(e) => setDonor((d) => ({ ...d, donor_name: e.target.value }))} />
        <Input data-testid="donor-email" type="email" placeholder="Your Email (optional)" value={donor.donor_email} onChange={(e) => setDonor((d) => ({ ...d, donor_email: e.target.value }))} />
        <Input data-testid="donor-message" placeholder="Optional message for the family" value={donor.message} onChange={(e) => setDonor((d) => ({ ...d, message: e.target.value }))} />
        <button data-testid="donate-btn" disabled={busy || !picked} onClick={donate} className="btn-pink w-full">
          {busy ? "Redirecting..." : "Donate Securely"}
        </button>
      </div>
    </div>
  );
}
